import { OUTreeContent } from '@monorepo/shared/components/OUTree';
import { t } from 'i18next';

export const OuPreSelection = () => {
  return (
    <div className="ou-tree-container">
      <div className="ou-tree-title">{t('common.ouTree.ouTreeTitle')}</div>
      <OUTreeContent />
    </div>
  );
};
